/**
 * Hair Quiz Insider - Track recommended products event after newsletter subscription
 */
window.hairQuizInsider = (function () {
  'use strict';

  var MAX_PRODUCTS = 6;
  var NEED_PREFIX = 'NEED-';

  function normalizeImage(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function buildProductUrl(product) {
    if (!product || !product.handle) return '';
    var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
    var base = window.location.origin + '/products/' + product.handle;
    return variantId ? base + '?variant=' + variantId : base;
  }

  function extractNeed(tags) {
    if (!tags || !tags.length) return '';
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf(NEED_PREFIX) === 0) {
        return tags[i].substring(NEED_PREFIX.length).toLowerCase();
      }
    }
    return '';
  }

  function buildCustomPayload(products, need, concern) {
    var custom = {
      need: need,
      concern: concern,
    };

    var count = Math.min(products.length, MAX_PRODUCTS);
    for (var i = 0; i < count; i++) {
      var p = products[i];
      if (!p) continue;
      var idx = i + 1;
      custom['product_' + idx + '_name'] = p.title || '';
      custom['product_' + idx + '_image'] = normalizeImage(p.featured_image);
      custom['product_' + idx + '_url'] = buildProductUrl(p);
    }

    return custom;
  }

  var IDENTIFY_DELAY_MS = 1000;

  function trackRecommendedProducts(email) {
    if (!window.Insider || typeof window.Insider.track !== 'function') {
      return;
    }

    var needsReinit = false;

    // Identify anonymous user on Insider so the event is linked to their profile.
    if (!window.hairQuizCustomerLogged && email) {
      window.insider_object = window.insider_object || {};
      window.insider_object.user = Object.assign({}, window.insider_object.user, { email: email });

      if (window.Insider.eventManager && typeof window.Insider.eventManager.dispatch === 'function') {
        window.Insider.eventManager.dispatch('init-manager:re-initialize');
        needsReinit = true;
      }
    }

    var products = Array.isArray(window.hairQuizProducts) ? window.hairQuizProducts : [];
    var tags = window.hairQuizUtils && typeof window.hairQuizUtils.getUrlParams === 'function'
      ? window.hairQuizUtils.getUrlParams().tags
      : [];

    var need = extractNeed(tags);
    var concern = '';
    const eventParams = buildCustomPayload(products, need, concern);

    function sendEvent() {
      window.Insider.track('events', [{
        event_name: 'hair_quiz_recommended_products',
        event_params: {
          custom: eventParams
        },
      }]);
    }

    // Give the SDK time to fire the identify/re-initialize request before the event,
    // so the anonymous profile is merged before Insider processes hair_quiz_recommended_products.
    if (needsReinit) {
      setTimeout(sendEvent, IDENTIFY_DELAY_MS);
    } else {
      sendEvent();
    }
  }

  var PENDING_KEY = 'hairQuizInsiderPending';
  var MAX_ATTEMPTS = 25;
  var POLL_INTERVAL_MS = 200;

  function waitForReady(cond, callback, attemptsLeft) {
    if (cond()) {
      callback();
      return;
    }
    if (attemptsLeft <= 0) return;
    setTimeout(function () {
      waitForReady(cond, callback, attemptsLeft - 1);
    }, POLL_INTERVAL_MS);
  }

  function processPending() {
    var raw;
    try {
      raw = sessionStorage.getItem(PENDING_KEY);
    } catch (e) { return; }
    if (!raw) return;

    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) { }

    var data;
    try { data = JSON.parse(raw) || {}; } catch (e) { return; }

    waitForReady(
      function () {
        return window.Insider
          && typeof window.Insider.track === 'function'
          && Array.isArray(window.hairQuizProducts)
          && window.hairQuizProducts.length > 0;
      },
      function () { trackRecommendedProducts(data.email); },
      MAX_ATTEMPTS
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processPending);
  } else {
    processPending();
  }

  return {
    trackRecommendedProducts: trackRecommendedProducts,
  };
})();
